import clsx from "clsx"
import { ReactNode } from "react"

interface Props {
    children: ReactNode
	className?: string
}

export default function PageBody({
    children, className
}:Props){
	return (
		<div className={clsx(
			"cmn_px",
			className
		)}>
			<div className="relative max-w-screen-pc mx-auto">
				{ children }
			</div>
		</div>
	)
}